import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_learn-18030_show-completion-hs-dashboard'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
